import "../Dashboard/dashboard.css"
import React, { useEffect, useState } from 'react';
import Topbar from '../../components/Topbar';
import Leftbar from '../../components/Leftsidebar';
import { Link } from 'react-router-dom';
import { showToast, updateBorrwerRatings, getBorrowerNegativeRatings, getBorrowerPositiveRatings, getBorrowerRejectedRatings, approveBorrowerRating, rejectBorrowerRating } from "../Utils/utils";
import ReactPaginate from 'react-paginate';
import { Row, Col, Modal, Button, Form } from "react-bootstrap";
import Loaderspinner from "../../components/Loader";

const BorrowerRatings = () => {
    const [showSidebar, setShowSidebar] = useState(false);
    const [assignedList, setAssignedList] = useState([]);
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false)
    const [show, setShow] = useState(false);
    const [projectId, setProjectId] = useState('');
    const [ratingType, setRatingType] = useState("pending");
    const [showRatingModal, setShowRatingModal] = useState(false);
    const [selectedRating, setSelectedRating] = useState(null);
    const [editRating, setEditRating] = useState({
        overall: 0,
        professionalism: 0,
        transparency: 0,
        execution: 0,
        review: ""
    });

    useEffect(() => {
        setPage(0);
    }, [ratingType]);


    useEffect(() => {
        fetchList();
    }, [page, ratingType]);

    const fetchList = async () => {
        try {
            setLoading(true)
            const limit = 10;
            const offset = page * limit;

            const apiCall =
                ratingType === "pending"
                    ? getBorrowerNegativeRatings
                    : ratingType === "rejected"
                    ? getBorrowerRejectedRatings
                    : getBorrowerPositiveRatings;

            const response = await apiCall({ limit, offset });

            setAssignedList(response?.data?.rows || []);
            if ((response?.data?.count || 0) < limit) {
                setTotalPages(page + 1);
            } else {
                setTotalPages(page + 2);
            }
        } catch (error) {
            console.error("Error fetching asignee list:", error);
        } finally {
            setLoading(false)
        }
    };

    const handleSidebar = () => {
        setShowSidebar(!showSidebar);
    };

    const handleSidebarClose = () => {
        setShowSidebar(false);
    };

    const openUpdateModal = (rating) => {
        setSelectedRating(rating);

        setEditRating({
            overall: rating.overall || 0,
            professionalism: rating.professionalism || 0,
            transparency: rating.transparency || 0,
            execution: rating.execution || 0,
            review: rating.review || ""
        });

        setShowRatingModal(true);
    };

    const StarRating = ({ value, onChange }) => {
        return (
            <div>
                {[1, 2, 3, 4, 5].map((star) => (
                    <span
                        key={star}
                        style={{
                            cursor: "pointer",
                            color: star <= value ? "#ffc107" : "#ccc",
                            fontSize: "20px"
                        }}
                        onClick={() => onChange(star)}
                    >
                        ★
                    </span>
                ))}
            </div>
        );
    };

    const handleUpdateRating = async () => {
        try {
            setLoading(true);

            const payload = {
                rating_id: selectedRating?.project?.borrower_rating_id.toString(),
                userid: selectedRating?.borrower?.userid,
                professionalism: editRating.professionalism,
                transparency: editRating.transparency,
                execution: editRating.execution,
                overall: editRating.overall,
                review: editRating.review,
            };
            const response = await updateBorrwerRatings(payload);

            if (response.status === 200) {
                showToast("Rating updated successfully", "success");
                setShowRatingModal(false);
                fetchList();
            } else {
                showToast("Failed to update rating", "error");
            }

        } catch (err) {
            console.error(err);
            showToast("Something went wrong", "error");
        } finally {
            setLoading(false);
        }
    };

    const handleApproveRating = async (id) => {
        try {
            setLoading(true);
            const response = await approveBorrowerRating(id);

            if (response.status === 200) {
                showToast("Rating approved successfully", "success");
                setShowRatingModal(false);
                fetchList();
            } else {
                showToast("Failed to approve rating", "error");
            }

        } catch (err) {
            console.error(err);
            showToast("Something went wrong", "error");
        } finally {
            setLoading(false);
        }
    };

    const handleRejectRating = async (id) => {
        try {
            setLoading(true);
            const response = await rejectBorrowerRating(id);

            if (response.status === 200) {
                showToast("Rating rejected successfully", "success");
                setShowRatingModal(false);
                fetchList();
            } else {
                showToast("Failed to reject rating", "error");
            }

        } catch (err) {
            console.error(err);
            showToast("Something went wrong", "error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {loading && <Loaderspinner />}
            <div className="g-sidenav-show bg-gray-100 min-vh-100">
                <div id="wrapper">
                    <Leftbar showSidebar={showSidebar} handleSidebarClose={handleSidebarClose} />
                    <main className="main-content border-radius-lg">
                        <Topbar handleSidebar={handleSidebar} />
                        <div className="header header-bg-lender pt-3">
                            <div className="col-lg-6 col-7">
                                <nav aria-label="breadcrumb" className="d-none d-md-inline-block ml-md-4" style={{ marginLeft: '30px' }}>
                                    <ol className="breadcrumb breadcrumb-links breadcrumb-dark" style={{ background: "transparent" }}>
                                        <li className="breadcrumb-item"><Link to="/dashboard"><i className="fas fa-home" /></Link></li>
                                        <li className="breadcrumb-item mt-2"><span className='' style={{ color: "#f6f9fc" }}>Borrwer Ratings</span></li>
                                    </ol>
                                </nav>
                            </div>
                            <div className="d-flex justify-content-center pt-2">
                                <div
                                    className={`List-tab ${ratingType === 'pending' ? 'List-tab-active' : 'List-tab-normal'} mr-3`}
                                    onClick={() => setRatingType("pending")}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <span>Needs Action</span>
                                </div>
                                <div
                                    className={`List-tab ${ratingType === 'active' ? 'List-tab-active' : 'List-tab-normal'} mr-3`}
                                    onClick={() => setRatingType("active")}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <span>Active Ratings</span>
                                </div>
                                <div
                                    className={`List-tab ${ratingType === 'rejected' ? 'List-tab-active' : 'List-tab-normal'}`}
                                    onClick={() => setRatingType("rejected")}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <span>Rejected</span>
                                </div>
                            </div>
                        </div>
                        <div className="container-fluid mt--6">
                            <div className="row">
                                <div className="col">
                                    <div className="card">
                                        <div className="card-header border-0">
                                            <div className="d-flex justify-content-between">
                                                <div className="row ">
                                                    <h5 className="mb-0 w-auto">Borrower Ratings — {ratingType === 'pending' ? 'Needs Action' : ratingType === 'rejected' ? 'Rejected' : 'Active Ratings'}</h5>
                                                    {/* <p
                                                        className="w-auto px-0"
                                                        data-tooltip-id="my-tooltip"
                                                        data-tooltip-content="A complete list of all projects created by borrowers. Use this report to review project details, check status, and ensure projects comply with platform guidelines."
                                                        data-tooltip-place="right"
                                                    >
                                                        <i className="fas fa-info-circle" />

                                                    </p>

                                                    <Tooltip id="my-tooltip" style={{ width: '30%' }} /> */}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="table-responsive">
                                            <table className="table align-items-center table-flush">
                                                <thead className="thead-light">
                                                    <tr>
                                                        <th>Project Name</th>
                                                        <th>Borrwer</th>
                                                        <th>Overall</th>
                                                        <th>Professionalism</th>
                                                        <th>Transparency</th>
                                                        <th>Execution</th>
                                                        <th>Comment</th>
                                                        {ratingType == 'pending' &&
                                                            <th>Action</th>
                                                        }
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {assignedList?.length > 0 ? (
                                                        assignedList.map((list, index) => (
                                                            <tr key={index}>
                                                                <td className="table-user">
                                                                    <div>
                                                                        <span>{list?.project?.project_name}</span>
                                                                    </div>
                                                                </td>

                                                                <td className="table-user">
                                                                    <div style={{ width: "120px" }}><span>{`${list?.borrower?.name} ${list?.borrower?.lastname}`}</span></div>
                                                                </td>
                                                                <td>
                                                                    {list?.overall}
                                                                </td>
                                                                <td className="table-user">
                                                                    {list?.professionalism}
                                                                </td>

                                                                <td className="table-user">
                                                                    {list?.transparency}
                                                                </td>
                                                                <td>
                                                                    {list?.execution}
                                                                </td>
                                                                <td>
                                                                    {list?.review || 'No comment'}
                                                                </td>
                                                                {ratingType == 'pending' &&
                                                                    <td>
                                                                        <div style={{ width: "150px" }}>
                                                                            <button className="viewproject-btn pull-right mb-1" onClick={() => handleApproveRating(list?.project?.borrower_rating_id)}>
                                                                                <span className="text-white">Approve Ratings</span>
                                                                            </button>
                                                                            <button className="viewproject-btn pull-right mb-1" onClick={() => openUpdateModal(list)}>
                                                                                <span className="text-white">Update Ratings</span>
                                                                            </button>
                                                                            <button className="viewproject-btn pull-right mb-1" style={{ background: "#d9534f" }} onClick={() => handleRejectRating(list?.project?.borrower_rating_id)}>
                                                                                <span className="text-white">Reject</span>
                                                                            </button>
                                                                        </div>
                                                                    </td>
                                                                }
                                                            </tr>
                                                        ))) :
                                                        < tr >
                                                            <td colSpan="10" className="text-center"><b>No records found</b></td>
                                                        </tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Row>
                                <Col xs={12}>
                                    <div className='paginate-css'>
                                        <ReactPaginate
                                            previousLabel="<"
                                            nextLabel=">"
                                            breakLabel="..."
                                            pageCount={totalPages}
                                            marginPagesDisplayed={1}
                                            pageRangeDisplayed={2}
                                            onPageChange={({ selected }) => setPage(selected)}
                                            containerClassName="pagination"
                                            activeClassName="active"
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </main>
                </div >
            </div >
            <Modal
                show={showRatingModal}
                onHide={() => setShowRatingModal(false)}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Update Rating</Modal.Title>
                </Modal.Header>

                <Modal.Body>

                    <p>
                        Editing rating for:{" "}
                        <b>{selectedRating?.borrower?.name}</b>
                    </p>
                    <div className="d-grid" style={{ gridTemplateColumns: "repeat(2, 1fr)" }}>
                        <Form.Group className="mb-3">
                            <Form.Label>Overall</Form.Label>
                            <StarRating
                                value={editRating.overall}
                                onChange={(val) =>
                                    setEditRating({ ...editRating, overall: val })
                                }
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Professionalism</Form.Label>
                            <StarRating
                                value={editRating.professionalism}
                                onChange={(val) =>
                                    setEditRating({ ...editRating, professionalism: val })
                                }
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Transparency</Form.Label>
                            <StarRating
                                value={editRating.transparency}
                                onChange={(val) =>
                                    setEditRating({ ...editRating, transparency: val })
                                }
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Execution</Form.Label>
                            <StarRating
                                value={editRating.execution}
                                onChange={(val) =>
                                    setEditRating({ ...editRating, execution: val })
                                }
                            />
                        </Form.Group>
                    </div>

                    <Form.Group>
                        <Form.Label>Comment</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            value={editRating.review}
                            onChange={(e) =>
                                setEditRating({
                                    ...editRating,
                                    review: e.target.value,
                                })
                            }
                        />
                    </Form.Group>

                </Modal.Body>

                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={() => setShowRatingModal(false)}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="primary"
                        onClick={handleUpdateRating}
                    >
                        Submit
                    </Button>
                </Modal.Footer>
            </Modal>
        </>

    );
};

export default BorrowerRatings;
